import { useSelector } from 'react-redux';
import { Promotion } from '..';
import { Heading } from '../../../components';

const SiteView = () => {
  const { currentDevelopment } = useSelector((state) => state.general);
  const developments = useSelector((state) => state.developments);
  const promotions = useSelector((state) => state.promotions);

  const regionDevelopment = developments.find(
    (dev) => dev.id === currentDevelopment.parentId,
  );

  const parentPromotions = promotions.filter(
    (promotion) => promotion.belongsTo == regionDevelopment.parentId,
  );

  const regionPromotions = promotions.filter(
    (promotion) => promotion.belongsTo == regionDevelopment.id,
    );
  const sitePromotions = promotions.filter(
    (promotion) => promotion.belongsTo == currentDevelopment.id,
  );

  return (
    <>
      <div className=''>
        <Heading label={`created by head office (uneditable)`} />

        <div className={'promotions-list'}>
          {parentPromotions.map((promotion) => {
            return <Promotion key={promotion.id} belongsTo={promotion.belongsTo} promotionToggle={promotion.enablePromotion} isParent {...promotion} />;
          })}
        </div>
      </div>

      <div className=''>
        <Heading label={`Created by Regional Office (Uneditable)`} />

        {regionPromotions.length > 0 && (
                <div className={'promotions-list'}>
                {regionPromotions.map((promotion) => {
                    return <Promotion key={promotion.id} belongsTo={promotion.belongsTo} promotionToggle={promotion.enablePromotion} isRegion {...promotion} />;
                })}
                </div>
            )}
      </div>

      <Heading label={`Created by ${currentDevelopment.name}`} />

      <div className={'promotions-list'}>
        {sitePromotions.map((promotion) => {
          return <Promotion key={promotion.id} belongsTo={promotion.belongsTo} promotionToggle={promotion.enablePromotion} isSite {...promotion} />;
        })}
      </div>
    </>
  );
};

export default SiteView;
